import React from 'react';
import { Divider, DividerProps } from 'antd';

/**
 * ScDivider - Wrapper cho antd 6 Divider
 * Tương thích props của antd Divider
 */
const ScDivider: React.FC<DividerProps> = (props) => <Divider {...props} />;

ScDivider.displayName = 'ScDivider';

export default ScDivider;
